// Banner Bar vs. common frame alternatives — data from the owner's comparison chart.
// Photo thumbnails sit in the column headers.

export const COMPARE_PRODUCTS = [
  { key: "banner-bar", name: "The Banner Bar", photo: "/assets/img/compare/compare-banner-bar.jpg", ours: true },
  { key: "fiber-frame", name: "Fiber Frame", photo: "/assets/img/compare/compare-fiber-frame.jpg" },
  { key: "a-frame", name: "Banner A-Frame", photo: "/assets/img/compare/compare-a-frame.jpg" },
  { key: "galvanized", name: "Galvanized Steel Frame", photo: "/assets/img/compare/compare-galvanized-steel.jpg" },
  { key: "tpost-rope", name: "T-Post & Rope", photo: "/assets/img/compare/compare-tpost-rope.jpg" },
];

// Each row: label + 5 values (Banner Bar, Fiber Frame, A-Frame, Galvanized, T-Post & Rope)
export const COMPARE_SECTIONS = [
  {
    title: "Build & Capability",
    rows: [
      { label: "Made in USA", values: ["YES", "YES", "NO", "NO", "YES"] },
      { label: "U.S. Patent", values: ["10,410,553 B2", "Unknown", "NO", "NO", "N/A"] },
      { label: "Wind resistance rating", values: ["High", "High", "Low", "Low", "Bad"] },
      { label: "Number of frame sizes", values: ["4 frame options — accommodate 7 banner sizes", "6 sizes", "2 sizes", "3 sizes", "N/A"] },
      { label: "Largest banner supported", values: ["4' × 16'", "4' × 10'", "77.5\" × 38\"", "4' × 8'", "—"] },
      { label: "Available V-shape (two banners)", values: ["YES", "?", "NO", "NO", "Possible"] },
      { label: "Adjustable to different sizes", values: ["YES", "NO", "NO", "NO", "YES"] },
      { label: "Supports double-sided banners", values: ["YES", "YES", "NO", "YES", "YES"] },
      { label: "Supports banners back to back", values: ["YES", "YES", "NO", "YES", "Not suggested"] },
      { label: "Works with stock banner sizes", values: ["YES", "YES", "NO", "YES", "N/A"] },
      { label: "Uses ground stake", values: ["NO", "YES", "YES", "NO", "NO"] },
      { label: "Uses ground sleeve", values: ["NO", "NO", "NO", "YES", "NO"] },
    ],
  },
  {
    title: "What You'll Need",
    rows: [
      { label: "Requires guy wires or rope", values: ["NO", "NO", "NO", "NO", "YES"] },
      { label: "Requires T-post", values: ["YES", "NO", "NO", "NO", "YES"] },
      { label: "Requires concrete", values: ["NO", "NO", "NO", "Suggested", "NO"] },
      { label: "Requires post driver", values: ["YES", "YES", "NO", "NO", "YES"] },
      { label: "Requires digging", values: ["NO", "NO", "NO", "YES", "NO"] },
      { label: "Requires zip ties", values: ["NO", "YES", "NO", "NO", "N/A"] },
      { label: "Requires rope", values: ["NO", "NO", "NO", "NO", "YES"] },
    ],
  },
  {
    title: "Parts & Upkeep",
    rows: [
      { label: "Includes bungees — Made in USA", values: ["YES", "NO", "NO", "NO", "N/A"] },
      { label: "Includes lightweight bungees (made overseas)", values: ["NO", "NO", "YES", "YES", "N/A"] },
      { label: "Replacement bungees available", values: ["YES — full inventory, Made in USA", "N/A", "NO", "NO", "N/A"] },
      { label: "Replacement parts available", values: ["YES — full inventory, Made in USA", "?", "NO", "NO", "N/A"] },
      { label: "Maintenance", values: ["Replace bungees, reinstall if needed", "Replace broken zip ties, reinstall if needed", "Replace bungees — good for short-term use only", "Replace bungees, reinstall if needed", "Not suggested"] },
      { label: "Ease of banner change", values: ["Fast & easy, bungees stay in place while changing banners", "Slow & cumbersome", "Fast & easy", "Bungees don't stay in place and no bungee retainer included", "Cumbersome"] },
    ],
  },
  {
    title: "Ownership",
    rows: [
      { label: "Estimated install time (minutes)", values: ["15-20*", "5-10*", "10-15*", "15-20*", "5-10*"] },
      { label: "Install instructions & videos", values: ["Helpful videos & printed instructions", "?", "Printed instructions", "Printed instructions", "N/A"] },
      { label: "Availability", values: ["Readily available — ships quickly — Made in USA", "?", "Readily available", "Readily available", "Readily available"] },
      { label: "Suggested uses", values: ["Best for repeat banner campaigns, especially in windy areas", "Good for ongoing banner campaigns", "Best for short-term use only", "Low budget", "Not suggested"] },
      { label: "Cons", values: ["T-posts easily removed with T-post puller (con is buying the T-post puller for $45 +/- but it's worth it)", "Ground stakes possible tripping hazard, difficult to remove", "Ground stakes, not good in winds over 15 mph, no replacement parts", "Ground sleeves too short, cheap bungees, frame looks cheap, no replacement parts, ground sleeves cause tripping hazard", "Banners don't last, looks unprofessional, T-posts collapse under wind load, not good for longer-term use"] },
      { label: "Advantages", values: ["Looks professional, bungees provide higher wind rating, adjustable size, uses readily available T-posts", "Looks professional", "Works on pavement (if no wind)", "No advantages", "Lowest cost"] },
    ],
  },
];

export const COMPARE_FOOTNOTES = [
  "*First-time install may take longer.",
  "Sign code: check your local codes for size & placement — this applies to every frame type.",
];
